import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import Reveal from "./Reveal";

export default function NewsletterBlock({ content }) {
  const c = content || {};
  const privacyNote = c.privacy_note || "Saya setuju menerima newsletter dari Heri Sensei.";
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!consent) {
      setError("Centang persetujuan untuk melanjutkan.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, name, consent });
      setDone(data);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-xl border border-line bg-indigo text-[#EAE6DF] px-6 sm:px-12 py-12 md:py-16">
            <span className="absolute top-6 right-6 w-2.5 h-2.5 rounded-full bg-enji" aria-hidden="true" />
            <div className="max-w-xl">
              <h2 className="font-serif text-3xl md:text-4xl tracking-tight text-[#F7F5F0]">
                {c.title || "Subscribe to My Newsletter"}
              </h2>
              <p className="mt-4 text-[#B8C2C9] leading-relaxed">
                {c.subtext || "Catatan tentang belajar, bertumbuh, dan melihat kehidupan dari sudut pandang yang lebih luas. Langsung ke email Anda."}
              </p>

              {done ? (
                <div data-testid="newsletter-success" className="mt-8 bg-[#FFFDFC]/10 border border-[#F7F5F0]/20 rounded-lg p-5 flex gap-3">
                  <CheckCircle2 className="text-[#C9D4DA] shrink-0 mt-0.5" size={20} />
                  <p className="text-[#F7F5F0] text-[15px] leading-relaxed">{done.message}</p>
                </div>
              ) : (
                <form onSubmit={submit} className="mt-8" noValidate={false}>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <input
                      data-testid="newsletter-name-input"
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Nama (opsional)"
                      className="field-input sm:max-w-[180px] !bg-[#FFFDFC]/10 !border-[#F7F5F0]/25 !text-[#F7F5F0] placeholder:!text-[#8FA0AA]"
                      aria-label="Nama"
                    />
                    <input
                      data-testid="newsletter-email-input"
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Alamat email Anda"
                      className="field-input flex-1 !bg-[#FFFDFC]/10 !border-[#F7F5F0]/25 !text-[#F7F5F0] placeholder:!text-[#8FA0AA]"
                      aria-label="Alamat email"
                    />
                    <button type="submit" data-testid="newsletter-submit-button" disabled={loading} className="btn-primary shrink-0">
                      {loading && <Loader2 size={16} className="animate-spin" />}
                      {c.cta_label || "Berlangganan"}
                    </button>
                  </div>
                  <label className="flex items-start gap-2.5 mt-4 text-[13px] text-[#B8C2C9] cursor-pointer">
                    <input
                      data-testid="newsletter-consent-checkbox"
                      type="checkbox"
                      checked={consent}
                      onChange={(e) => setConsent(e.target.checked)}
                      className="mt-0.5 w-4 h-4 accent-[#C84B55]"
                      required
                    />
                    <span>
                      {privacyNote}{" "}
                      <Link to="/privasi" className="underline underline-offset-2 hover:text-white">Kebijakan Privasi</Link>
                    </span>
                  </label>
                  {error && (
                    <p data-testid="newsletter-error" className="mt-3 text-sm text-[#F0B9BE]" role="alert">{error}</p>
                  )}
                </form>
              )}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
